module.exports = __webpack_public_path__ + "img/attack_meteor.189d44dd.png";